import { render, staticRenderFns } from "./BoostMerchantList.vue?vue&type=template&id=53e53880"
import script from "./BoostMerchantList.vue?vue&type=script&lang=js"
export * from "./BoostMerchantList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports